import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchCropFields(organization_id, crop_field_location_id, current_page, rows_per_page) {
    return RequesterV1.get(
      `organization/partners/crop_fields/list_crop_fields/fetch_crop_fields/${organization_id}/${crop_field_location_id}/${current_page}/${rows_per_page}`
    );
  },

  filterCropfields(organization_id, crop_field_location_id, filters){
    var str = Object.keys(filters)
      .filter(key => filters[key] != null)
      .map(key => {
        return `${key}=${encodeURIComponent(filters[key])}`
      })
      .join("&");
    return RequesterV1.get(
      `organization/partners/crop_fields/list_crop_fields/filter_crop_fields/${organization_id}/${crop_field_location_id}?${str}`
    );
  },

  fetchLocations(organization_id) {
    return RequesterV1.get(
      "organization/partners/crop_fields/list_crop_fields/fetch_locations/" + organization_id
    );
  },

  downloadCropFieldsXlsx(organization_id, crop_field_location_id) {
    return RequesterV1.get(
      `organization/partners/crop_fields/list_crop_fields/${organization_id}/download_crop_fields_xlsx/${crop_field_location_id}`,
      { responseType: "blob" }
    );
  },

  updateCropFieldsXlsx(organization_id, crop_field_location_id, file) {
    return RequesterV1.post(
      `organization/partners/crop_fields/list_crop_fields/${organization_id}/update_crop_fields_xlsx/${crop_field_location_id}`,
      file
    );
  },
};
